import { Route } from '@angular/router';

export const doublesTrainingStatisticsRoutes: Route[] = [
    {
        path: 'doubles-training/details',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/doubles-training-statistics-details/doubles-training-statistics-details.component').then(
                (c) => c.DoublesTrainingStatisticsDetailsComponent
            ),
    },
    {
        path: 'doubles-training/games/tab/:tab',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/doubles-training-statistics-games/doubles-training-statistics-games.component').then(
                (c) => c.DoublesTrainingStatisticsGamesComponent
            ),
    },
    {
        path: 'doubles-training/games/:id',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import(
                './pages/doubles-training-statistics-games-details/doubles-training-statistics-games-details.component'
            ).then((c) => c.DoublesTrainingStatisticsGamesDetailsComponent),
    },
];
